import { render, staticRenderFns } from "./AddCompany.vue?vue&type=template&id=b42ce2e8&"
import script from "./AddCompany.vue?vue&type=script&lang=js&"
export * from "./AddCompany.vue?vue&type=script&lang=js&"
import style0 from "./AddCompany.vue?vue&type=style&index=0&id=b42ce2e8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports